"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
const react_1 = tslib_1.__importDefault(require("react"));
const reactstrap_1 = require("reactstrap");
const reusables_1 = require("../../../comps/reusables");
const graphql_1 = require("../../../graphql");
const react_2 = require("@osmosys/react");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
exports.CreateIntegrationDetail = ({ isOpen, onClose, integrationType, }) => {
    const { history } = use_react_router_1.default();
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(react_2.OsmosysModal, { osysName: "CreateIntegrationDetail", isOpen: !!isOpen, centered: true, toggle: () => {
                onClose();
            } },
            react_1.default.createElement(reactstrap_1.ModalHeader, { toggle: () => {
                    onClose();
                } },
                "Name your new ",
                integrationType ? integrationType.name : '',
                ' ',
                "integration"),
            react_1.default.createElement(reactstrap_1.ModalBody, null,
                react_1.default.createElement(reusables_1.Form, { mutationProps: {
                        mutation: graphql_1.createIntegration,
                        onCompleted: data => {
                            history.push(`/integrations/${data.createIntegration.id}`);
                        },
                    }, valuesToVariables: values => ({
                        data: {
                            name: values.name,
                            type: integrationType.type,
                        },
                    }), formikProps: {
                        initialValues: {
                            name: '',
                        },
                    } }, (formikProps, result) => (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(reusables_1.FormGroup, { name: "name", label: "Name" }),
                    react_1.default.createElement(reusables_1.AjaxButton, { type: "submit", color: "success", className: "w-100", icon: pro_solid_svg_icons_1.faPlus, label: "Create", error: result.error, loading: result.loading, success: !!result.data, onClick: () => formikProps.handleSubmit() }),
                    react_1.default.createElement(react_2.OsmosysErrorAlert, { resource: "Integration", action: "create", 
                        // marginTop
                        // marginBottom={false}
                        // dismissable
                        apolloError: result.error }))))))));
};
//# sourceMappingURL=CreateIntegrationDetail.js.map